import { createSelector } from '@reduxjs/toolkit';

import { Organization } from '@paragon/contract-library';
import { naturalSortByProperty } from '@paragon/utilities';

import { RootState } from '../store';

export const getOrganizationsSorted = createSelector(
  (state: RootState) => state.organizations,
  (organizations) => {
    const sortedLocationsOrganizations: readonly Organization[] = organizations.map((organization) => ({
      ...organization,
      locations: naturalSortByProperty(organization.locations, (location) => location),
    }));
    return naturalSortByProperty(sortedLocationsOrganizations, (organization) => organization.name);
  },
);
